import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { getLatestArticles } from "@/lib/content";

export default function RecommendedGrid() {
  const picks = getLatestArticles(8).slice(2, 8);
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="Picked"
          title="新瓜推荐"
          desc="编辑从今日更新里挑出来的六条，覆盖影视、综艺、音乐与时尚，碎片时间也能快速读完。"
          action={{ label: "全部瓜田", path: "/category/star" }}
        />
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {picks.map((item) => (
            <ArticleCard key={item.id} article={item} />
          ))}
        </div>
      </div>
    </section>
  );
}